module.exports = __webpack_public_path__ + "static/media/ocm-logo.6c3c1f4b.svg";